export default __webpack_public_path__ + "static/media/marketing.9617cdf6.svg";